import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
} from '@mui/material';

const ColumnSelectorModal = ({ columns, isOpen, onClose, onSelect }) => {
  const [sourceColumn, setSourceColumn] = useState('');
  const [targetColumn, setTargetColumn] = useState('');
  const [labelColumn, setLabelColumn] = useState('');

  const handleSelect = () => {
    if (sourceColumn && targetColumn && labelColumn) {
      onSelect([sourceColumn, targetColumn, labelColumn]);
      onClose();
    } else {
      console.error('Please select all three columns.');
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Typography align="center">Select Data Points</Typography>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center">
          <FormControl fullWidth sx={{ mt: 1, mb: 2, width: '250px' }}>
            <InputLabel>Source</InputLabel>
            <Select
              value={sourceColumn}
              onChange={(e) => setSourceColumn(e.target.value)}
              label="Source Column"
            >
              {columns.map((col) => (
                <MenuItem key={col} value={col}>
                  {col}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth sx={{ mb: 2, width: '250px' }}>
            <InputLabel>Destination</InputLabel>
            <Select
              value={targetColumn}
              onChange={(e) => setTargetColumn(e.target.value)}
              label="Target Column"
            >
              {columns.map((col) => (
                <MenuItem key={col} value={col}>
                  {col}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth sx={{ mb: 2, width: '250px' }}>
            <InputLabel>Action</InputLabel>
            <Select
              value={labelColumn}
              onChange={(e) => setLabelColumn(e.target.value)}
              label="Label Column"
            >
              {columns.map((col) => (
                <MenuItem key={col} value={col}>
                  {col}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSelect} color="primary">
          Select
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ColumnSelectorModal;